import { code } from "@spscommerce/utils";

export const SpsDropdownExamples = {
    regular: {
        label: "Regular DropDowns",
        description: `<p>Info about dropdown demos</p>`,
        examples: {
            withLabelVariants: {
                description: `<p>With label, style variants</p>`,
                template: code`
                    <sps-dropdown label="Dropdown" class="mr-1 mb-1" id="regular">
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                            <sps-dropdown-option disabled>
                                Disabled Option
                            </sps-dropdown-option>
                    </sps-dropdown>
                    <sps-dropdown label="Dropdown" kind="key" class="mr-1 mb-1">
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                    </sps-dropdown>
                    <sps-dropdown label="Dropdown" kind="confirm" class="mr-1">
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                    </sps-dropdown>
                    <sps-dropdown label="Dropdown" kind="delete">
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                    </sps-dropdown>
                `
            },
            withLabelAndIcon: {
                description: `<p>With label and icon</p>`,
                template: code`
                    <sps-dropdown icon="drill" label="Dropdown" class="mr-1 mb-1">
                        <sps-dropdown-option>Option</sps-dropdown-option>
                    </sps-dropdown>
                    <sps-dropdown icon="key" label="Dropdown" kind="key" class="mr-1 mb-1">
                        <sps-dropdown-option>Option</sps-dropdown-option>
                    </sps-dropdown>
                    <sps-dropdown icon="rocket" label="Dropdown" kind="confirm" class="mr-1">
                        <sps-dropdown-option>Option</sps-dropdown-option>
                    </sps-dropdown>
                    <sps-dropdown icon="trash" label="Dropdown" kind="delete">
                        <sps-dropdown-option>Option</sps-dropdown-option>
                    </sps-dropdown>
                `
            },
            iconOnly: {
                description: `<p>Icon only</p>`,
                template: code`
                    <sps-dropdown class="mr-1">
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                    </sps-dropdown>
                    <sps-dropdown icon="gear">
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                    </sps-dropdown>
                `
            },
            doStuff: {
                description: `<p>Making options do stuff</p>`,
                template: code`
                    <sps-dropdown label="Dropdown">
                        <sps-dropdown-option (click)="alertOnClick()">
                            Click Handler
                        </sps-dropdown-option>
                        <sps-dropdown-option routerLink="/components/card">
                            Router Link
                        </sps-dropdown-option>
                        <sps-dropdown-option href="https://google.com">
                            HREF Link
                        </sps-dropdown-option>
                    </sps-dropdown>
                `
            },
            disabled: {
                description: `<p>Disabled</p>`,
                template: code`
                    <sps-dropdown icon="drill" label="Dropdown" class="mr-1" id="disabled" disabled>
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                    </sps-dropdown>
                    <sps-dropdown disabled tabindex="1">
                        <sps-dropdown-option>
                            Option
                        </sps-dropdown-option>
                    </sps-dropdown>
                `
            }
        }
    },
    checkbox: {
        label: "Checkbox With Dropdown",
        description: `<p>Info about checkboxes with dropdowns</p>`,
        examples: {
            checkbox: {
                template: code`
                    <sps-table #table selectable>
                        <sps-thead>
                            <sps-tr>
                                <sps-th controlCell>
                                    <sps-checkbox-dropdown [(checked)]="table.allSelected"
                                        [indeterminate]="table.partiallySelected">
                                        <sps-dropdown-option icon="file-size">Select All Results</sps-dropdown-option>
                                        <sps-dropdown-option icon="file-solid">Select This Page</sps-dropdown-option>
                                        <sps-dropdown-option icon="ban">Select None</sps-dropdown-option>
                                        <sps-dropdown-option icon="star">Select All Favorites</sps-dropdown-option>
                                        <sps-dropdown-option icon="item-tag">Select All by Tag…</sps-dropdown-option>
                                    </sps-checkbox-dropdown>
                                </sps-th>
                                <sps-th>
                                    ID
                                </sps-th>
                                <sps-th>
                                    Foobar
                                </sps-th>
                            </sps-tr>
                        </sps-thead>
                        <sps-tbody>
                            <sps-tr>
                                <sps-td>123</sps-td>
                                <sps-td>Florp</sps-td>
                            </sps-tr>
                            <sps-tr>
                                <sps-td>234</sps-td>
                                <sps-td>Gllazx</sps-td>
                            </sps-tr>
                            <sps-tr>
                                <sps-td>345</sps-td>
                                <sps-td>Qudlob</sps-td>
                            </sps-tr>
                            <sps-tr>
                                <sps-td>456</sps-td>
                                <sps-td>Ytrtrrt</sps-td>
                            </sps-tr>
                            <sps-tr>
                                <sps-td>567</sps-td>
                                <sps-td>Arvfrus</sps-td>
                            </sps-tr>
                        </sps-tbody>
                    </sps-table>
                `
            }
        }
    },
    spinning: {
        label: "Spinning Dropdown",
        description: `<p>Info about dropdowns with spinner</p>`,
        examples: {
            checkbox: {
                template: code`
                    <sps-dropdown [spinning]="true" label="Dropdown" class="mr-1 mb-1">
                    <sps-dropdown-option>
                        Option
                    </sps-dropdown-option>
                        <sps-dropdown-option disabled>
                            Disabled Option
                        </sps-dropdown-option>
                    </sps-dropdown>
                `
            }
        }
    }
};
